import React from 'react';

import { ScreenGo, ScreenLink, useScreenState } from '@gogame/screens';

import Actions from 'scenes/Gallery/GalleryPage/ConceptFamilies/Actions';
import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import {
  AttributeItem,
  AttributeList,
} from 'scenes/Gallery/components/AttributeList';
import { THUMBNAIL_URL } from 'scenes/Gallery/components/File/constants';
import { Tile } from 'scenes/Gallery/components/Tiles';
import {
  CONCEPT_FAMILY_ID,
  TAB_CONCEPTS,
} from 'scenes/Gallery/GalleryPage/constants';
import { conceptFamilyPreviewLink } from 'scenes/Gallery/GalleryPage/navigation';

const ConceptFamiliesTile = ({
  data,
  isSelected,
  onSelect,
  openChildComponent,
}) => {
  const screenState = useScreenState();

  const {
    [CONCEPT_FAMILY.ID]: id,
    [CONCEPT_FAMILY.NAME]: name,
    [CONCEPT_FAMILY.APPLICATIONS]: applications,
    [CONCEPT_FAMILY.CONCEPTS_COUNT]: conceptsCount,
    [CONCEPT_FAMILY.CREATIVES_COUNT]: creativesCount,
    [CONCEPT_FAMILY.ORIGINAL]: original,
    [CONCEPT_FAMILY.ACTIONS]: actions,
  } = data;

  const {
    [CREATIVE.FILE]: { [THUMBNAIL_URL]: originalFileThumbnailURL } = {},
  } = original || {};

  return (
    <Tile
      selected={isSelected(data)}
      onSelect={onSelect(data)}
      id={id}
      name={name}
      previewSrc={originalFileThumbnailURL}
      renderPreview={({ previewComponent }) => (
        <ScreenGo to={`${id}`} data-cy={'Creative Details'}>
          {previewComponent}
        </ScreenGo>
      )}
      title={
        <ScreenLink
          data-cy={'Concept Family Page'}
          underline={'always'}
          link={conceptFamilyPreviewLink.child(TAB_CONCEPTS)}
          pathParams={{
            [CONCEPT_FAMILY_ID]: id,
          }}
          searchParams={{
            filters: screenState.filters,
          }}
        >
          {name}
        </ScreenLink>
      }
      content={applications.join(' | ')}
      attributes={
        <AttributeList>
          <AttributeItem valueParser={'conceptsCount'} value={conceptsCount} />
          <AttributeItem
            valueParser={'creativesCount'}
            value={creativesCount}
          />
        </AttributeList>
      }
      actions={
        <Actions
          actions={actions}
          data={data}
          limit={0}
          openChildComponent={openChildComponent}
          color={'inherit'}
        />
      }
    />
  );
};

export default ConceptFamiliesTile;
